import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportOpportunityView,
    EntityTypeCustomFieldDto,
    GetOpportunityColumnChartValuesResultType,
    GetOpportunityLineChartValuesResultType,
    GetOpportunityMetricsValuesResultType,
    GetOpportunityValuesParameters,
    GetOpportunityValuesResultType,
    OpportunityClient,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportingOpportunityService extends CustomReportServiceBase<
    OpportunityClient,
    CustomReportOpportunityView
> {
    constructor(protected override client: OpportunityClient) {
        super(client);
    }

    async getOpportunityValues(body: GetOpportunityValuesParameters): Promise<GetOpportunityValuesResultType[]> {
        return await lastValueFrom(this.client.opportunityGetOpportunityValues(body));
    }

    async getOpportunityMetricsValues(
        body: GetOpportunityValuesParameters
    ): Promise<GetOpportunityMetricsValuesResultType> {
        return await lastValueFrom(this.client.opportunityGetOpportunityMetricsValues(body));
    }

    async getOpportunityBoxesValues(body: GetOpportunityValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.opportunityGetOpportunityBoxesValues(body));
    }

    async getOpportunityLineChartValues(
        body: GetOpportunityValuesParameters
    ): Promise<GetOpportunityLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.opportunityGetOpportunityLineChartValues(body));
    }

    async getOpportunityColumnChartValues(
        body: GetOpportunityValuesParameters
    ): Promise<GetOpportunityColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.opportunityGetOpportunityColumnChartValues(body));
    }

    override async saveCustomReport(body: CustomReportOpportunityView): Promise<CustomReportOpportunityView> {
        if (body.isPublic) return await lastValueFrom(this.client.opportunitySaveCatalogReport(body));
        else return await lastValueFrom(this.client.opportunitySaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportOpportunityView> {
        return await lastValueFrom(this.client.opportunityGetCustomReport(id));
    }

    override async shareReport(body: CustomReportOpportunityView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.opportunityCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportOpportunityView> {
        return await lastValueFrom(this.client.opportunityGetSharedReport(id));
    }

    async getCustomFieldColumns(organizationIds: number[]): Promise<EntityTypeCustomFieldDto[]> {
        return await lastValueFrom(this.client.opportunityGetCustomFieldColumns(organizationIds));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.opportunityResultAvailableColumns(organizationIds));
    }
}
